module.exports = __webpack_public_path__ + "img/currency_icon_manager_white.svg";